export default __webpack_public_path__ + "locales/vi/PaymentsEnterprise.json?hash=191bbceeb34f9ebef06dfc0fb96a5f22";